import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Custom log function

const deleteFolderFile = async (
  folderId,
  token,
  type,
  docId = null,
  file_id = "vide",
  prefix
) => {
  let url = "";

  // remove / from file_id and rreplace with %2F
  file_id = file_id.replace(/\//g, "%MF");

  // Construct URL based on the type
  if (type === "doc") {
    url = prefix + `folders/${folderId}/documents/${docId}/file/${file_id}`;
  } else {
    url = prefix + `folders/${folderId}/${type}/${file_id}`;
  }

  // Define the request body
  const body = {
    type: type,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the DELETE request
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Additional optional fields can be provided here
      "",
      JSON.stringify(body), // Request body as string
      await response.text() // Response body as text
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      return ""; // Success message or further processing
    } else {
      // Handle error response
      console.error(`Failed to delete file: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default deleteFolderFile;
